<template>
  <g fill-rule="evenodd">
    <path
      d="M0 14.4c0 .31.18.6.47.73l8.8 4c.21.1.45.1.66 0l8.8-4a.8.8 0 000-1.46L15.05 12l3.68-1.67a.8.8 0 000-1.46L15.05 7.2l3.68-1.67a.8.8 0 000-1.46l-8.8-4a.8.8 0 00-.66 0l-8.8 4a.8.8 0 000 1.46L4.15 7.2.47 8.87a.8.8 0 000 1.46L4.15 12 .47 13.67a.8.8 0 00-.47.73z"
    />
    <path
      d="M6.08 12.88l3.2 1.45c.21.1.45.1.66 0l3.18-1.45 3.35 1.52-6.87 3.12-6.87-3.12 3.35-1.52zM6.08 8.08l3.2 1.45c.21.1.45.1.66 0l3.18-1.45 3.35 1.52-6.87 3.12L2.73 9.6l3.35-1.52zM9.6 1.68l6.87 3.12L9.6 7.92 2.73 4.8z"
      class="secondary-color"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FeaturesIcon",
});
</script>
